import { MfaChallengeType } from 'pages/mfa/models';

const UNKOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export interface IProfileInfo {
  firstName: string;
  lastName: string;
  emailAddress: string;
  bEmailAlerts: boolean;
  enabledMfaChallengeTypes?: Array<MfaChallengeType | number>;
  availableMfaChallengeTypes?: Array<MfaChallengeType | number>;
  bMFAEnabled?: boolean;
}

export interface IProfileDeatilsForm {
  firstName: string;
  lastName: string;
  emailAddress: string;
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export class ProfileParser {
  public static createEmptyProfileDetails = (
    details: IProfileInfo
  ): IProfileDeatilsForm => ({
    firstName: details.firstName,
    lastName: details.lastName,
    emailAddress: details.emailAddress,
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });

  public static parseError = (errors: any) => {
    let error: string;
    switch (errors[0].messageCode) {
      case 'EmailAddress_Already_Exists':
        error = 'Email already exists';
        break;
      case 'Current_Password_Incorrect':
        error = 'Your current password is incorrect';
        break;
      case 'Current_Password_Required':
        error = 'Please enter your current password to set a new one';
        break;
      case 'OfficeEmailAddress_Already_Exists':
        error = 'Office email already exists';
        break;        
      case 'Invalid_ArchivingDate':
        error = 'Invalid archiving date ';
        break;
      case 'Password_Must_Be_At_Least_Eight_Characters':
        error = 'Password must be at least eight characters';
        break;
      default:
        error = UNKOWN_ERROR_MESSAGE;
    }
    return error;
  };
}
